<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6">
          <h4 class="mb-0">تخصیص PM V2 به تجهیزات</h4>
        </div>

      </div>


      <div class="card card-statistics mt-3 mb-30">
        <div class="card-body">
          <div class="row">
            <div class="form-group col-md-4"><label>عنوان قالب</label><input class="form-control" type="text"
                placeholder="برای جستجوی ، اینجا تایپ کنید ..." [(ngModel)]="TemplateTitle"></div>
            <div class="form-group col-md-2"><label>وضعیت</label><select class="custom-select"
                [(ngModel)]="ActiveFilter">
                <option [ngValue]="true">فعال</option>
                <option [ngValue]="false">غیرفعال</option>
              </select></div>
            <div class="form-group col-md-3"><label>گروه تجهیز</label><select class="custom-select"
                [(ngModel)]="GroupId" (change)="ReadSubGroups()">
                <option [ngValue]="0">همه موارد</option>
                <option *ngFor="let item of GroupList" [ngValue]="item.id">{{ item.title }}</option>
              </select></div>
            <div class="form-group col-md-3"><label>زیرگروه تجهیز</label><select class="custom-select"
                [(ngModel)]="SubGroupId" [disabled]="GroupId === 0">
                <option [ngValue]="0">همه موارد</option>
                <option *ngFor="let item of SubGroupList" [ngValue]="item.id">{{ item.title }}</option>
              </select></div>
            <div class="form-group col-md-6"><label>کلیدواژه تجهیز</label><input class="form-control" type="text"
                [(ngModel)]="DeviceKeyword" (keyup.enter)="ReadData()" placeholder="کد BEHFA، شرح، سازنده یا مدل"></div>
            <div class="form-group col-md-6 mt-4">
              <button type="button" class="btn btn-info" style="margin-left: 5px;" [disabled]="Procssing"
                (click)="ReadData()"><i class="fa fa-search"></i> جستجوی اطلاعات </button>
              <button class="btn btn-success" type="button" (click)="Add()"><i class="fa  fa-plus-circle"></i> فرم تخصیص
                جدید </button>
            </div>
          </div>
        </div>
      </div>

      <button *ngIf="ActiveFilter" type="button" class="btn btn-danger mb-3"
        [disabled]="SelectedAssignmentIds.size === 0 || Procssing" (click)="openModal(template)">غیرفعال‌سازی
        انتخاب‌شده‌ها</button>
      <div *ngIf="Procssing" class="text-center p-3">در حال دریافت اطلاعات...</div>
      <div *ngIf="!Procssing" class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th><input type="checkbox" [checked]="AllCurrentSelected"
                  (change)="ToggleAllCurrent($any($event.target).checked)"></th>
              <th>#</th>
              <th>Code BEHFA</th>
              <th>Model</th>
              <th>Manufacturer</th>
              <th>Description</th>
              <th>Group</th>
              <th>Template</th>
              <th>Version</th>
              <th>Status</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList| paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList.length
                      }; let i = index">
              <td><input type="checkbox" [checked]="IsSelected(item.id)"
                  (change)="ToggleRow(item.id, $any($event.target).checked)"></td>
              <td>{{ i + 1 }}</td>
              <td>{{ item.codeBEHFA }}</td>
              <td>{{ item.model }}</td>
              <td>{{ item.manufacturer }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.GroupTitle }}</td>
              <td>{{ item.PM_Code }} - {{ item.PM_Title }}</td>
              <td>{{ item.Version }}</td>
              <td>
                <p *ngIf="item.Active" style="color: #489b39;">فعال</p>
                <p *ngIf="!item.Active" style="color: crimson;">غیر فعال</p>

              </td>
              <td><button type="button" class="btn btn-warning" (click)="Detail(item.id)"> جزئیات</button></td>
            </tr>
            <tr *ngIf="DataList.length === 0">
              <td colspan="11">رکوردی وجود ندارد.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      تخصیص‌های انتخاب‌شده غیرفعال شوند؟
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeactivateSelected()"> غیرفعال اطلاعات <i
        class="fa fa-lock"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>